import React from 'react';

import Main from '../components/Main';

const Home = ({ children }) => <Main>{children}</Main>;

export default Home;
